import { render, staticRenderFns } from "./FormPermissionManager.vue?vue&type=template&id=607c7e86&scoped=true&"
import script from "./FormPermissionManager.vue?vue&type=script&lang=js&"
export * from "./FormPermissionManager.vue?vue&type=script&lang=js&"
import style0 from "./FormPermissionManager.vue?vue&type=style&index=0&id=607c7e86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607c7e86",
  null
  
)

export default component.exports